import { useMutation } from '@apollo/client';

import { EVENTS } from '../../event/graphql/query/eventsQuery.graphql';
import { MILESTONES } from '../../event/graphql/query/milestonesQuery.graphql';
import { DELETE_MILESTONE } from '../graphql/mutation/deleteMilestoneMutation.graphql';

export const useDeleteMilestoneMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(DELETE_MILESTONE, { onCompleted });

  const deleteMilestone = (milestoneId: string) => {
    mutate({
      variables: {
        milestoneId,
      },
      refetchQueries: [EVENTS, MILESTONES],
    });
  };

  return { deleteMilestone };
};
